import React from "react";
// import './App.css';
// import "../..scss/_custom.scss"
// import '../Style.scss'

import { CSpinner } from "@coreui/react";

const Loader = () => {
  return (
    <div className="backdrop--placeholder">
      <div className="bc-con">
        <CSpinner animation="border" role="status"></CSpinner>
      </div>
    </div>
  );
};

export default Loader;
